jQuery(document).ready(function($) {
    // Initialize AOS
    AOS.init({
        duration: 800,
        once: true,
    });

	// Mobile Material flyout drawer
	(function initMobileDrawer() {
		var toggle = document.getElementById('mobile-menu-button');
		var drawer = document.getElementById('mobile-drawer');
		if (!toggle || !drawer) {
			return;
		}

		var closeControls = drawer.querySelectorAll('[data-mobile-drawer-close]');
		var panel = drawer.querySelector('.mobile-drawer__panel');
		var lastFocus = null;

		function setOpen(isOpen) {
			drawer.classList.toggle('is-open', isOpen);
			drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
			toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
			toggle.setAttribute('aria-label', isOpen ? 'Close Menu' : 'Open Menu');
			document.documentElement.classList.toggle('mobile-drawer-open', isOpen);

			if (isOpen) {
				lastFocus = document.activeElement;
				if (panel) {
					panel.focus();
				}
			} else if (lastFocus && typeof lastFocus.focus === 'function') {
				lastFocus.focus();
			}
		}

		toggle.addEventListener('click', function() {
			setOpen(!drawer.classList.contains('is-open'));
		});

		closeControls.forEach(function(control) {
			control.addEventListener('click', function() {
				setOpen(false);
			});
		});

		document.addEventListener('keydown', function(event) {
			if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
				setOpen(false);
			}
		});

		if (panel && !panel.hasAttribute('tabindex')) {
			panel.setAttribute('tabindex', '-1');
		}
	})();

	$('.calendar-button a').click(function(event) {
		event.preventDefault();
		var hrefValue = $(this).attr('href');
		$(hrefValue).toggle();
	});
	handleScroll('.fadein', 'faded');
	handleScroll('.fadeinleft', 'faded-left');
	handleScroll('.fadeinright', 'faded-right');

	$(window).scroll(function() {
		handleScroll('.fadein', 'faded');
		handleScroll('.fadeinleft', 'faded-left');
		handleScroll('.fadeinright', 'faded-right');
	});

	function handleScroll(element, className) {
		$(element).each(function() {
			var top_of_element = $(this).offset().top;
			var bottom_of_element = top_of_element + $(this).outerHeight();
			var top_of_window = $(window).scrollTop();
			var bottom_of_window = top_of_window + $(window).height();

			if (bottom_of_window > top_of_element && top_of_window < bottom_of_element) {
				$(this).addClass(className);
			} else {
				$(this).removeClass(className);
			}
		});
	}

	$('.hero-slider > .wp-block-group__inner-container').slick({
		// Your slick options here
		dots: true,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 5000,
		// etc.
	});

	pbcBindEventsHero($);
	pbcBindMapHeroStory($);
});

function pbcBindMapHeroStory($) {
	if (!$ || typeof $.fn.slick !== 'function') {
		return;
	}

	document.querySelectorAll('[data-map-hero-slider]').forEach(function (node) {
		if (node.getAttribute('data-slider-ready') === 'true') {
			return;
		}
		if (node.children.length < 2) {
			return;
		}
		node.setAttribute('data-slider-ready', 'true');

		$(node).slick({
			dots: true,
			arrows: true,
			fade: true,
			cssEase: 'linear',
			autoplay: true,
			autoplaySpeed: 6500,
			speed: 500,
			pauseOnHover: true,
			adaptiveHeight: true,
			prevArrow: '<button type="button" class="map-hero__arrow map-hero__arrow--prev" aria-label="Previous story"></button>',
			nextArrow: '<button type="button" class="map-hero__arrow map-hero__arrow--next" aria-label="Next story"></button>'
		});
	});
}

function pbcBindEventsHero($) {
	var root = document.querySelector('.events-hero');
	if (!root || !$ || typeof $.fn.slick !== 'function') {
		return;
	}

	var $slider = $(root).find('[data-events-hero-slider]');
	if (!$slider.length || $slider.children().length < 2) {
		return;
	}

	var spotlight = root.querySelector('[data-events-hero-spotlight]');
	var kicker = spotlight ? spotlight.querySelector('.events-hero__spotlight-kicker') : null;
	var cost = spotlight ? spotlight.querySelector('.events-hero__spotlight-cost') : null;
	var dow = spotlight ? spotlight.querySelector('.events-hero__spotlight-dow') : null;
	var day = spotlight ? spotlight.querySelector('.events-hero__spotlight-day') : null;
	var title = spotlight ? spotlight.querySelector('.events-hero__spotlight-title') : null;
	var excerpt = spotlight ? spotlight.querySelector('.events-hero__spotlight-excerpt') : null;
	var time = spotlight ? spotlight.querySelector('.events-hero__spotlight-time') : null;
	var place = spotlight ? spotlight.querySelector('.events-hero__spotlight-place') : null;

	function syncSpotlight(slide) {
		if (!spotlight || !slide) {
			return;
		}
		var url = slide.getAttribute('data-url') || '';
		var eventTitle = slide.getAttribute('data-title') || '';
		var type = slide.getAttribute('data-type') || '';
		var excerptText = slide.getAttribute('data-excerpt') || '';
		var timeText = slide.getAttribute('data-time') || '';
		var placeText = slide.getAttribute('data-place') || '';
		var costText = slide.getAttribute('data-cost') || '';
		var isFree = slide.getAttribute('data-free') === '1';

		if (url) {
			spotlight.setAttribute('href', url);
		}
		if (kicker) {
			kicker.textContent = type || 'Upcoming';
		}
		if (cost) {
			cost.textContent = costText;
			cost.hidden = !costText;
			cost.classList.toggle('is-free', isFree);
		}
		if (dow) {
			dow.textContent = slide.getAttribute('data-dow') || '';
		}
		if (day) {
			day.textContent = slide.getAttribute('data-day') || '';
		}
		if (title) {
			title.textContent = eventTitle;
		}
		if (excerpt) {
			excerpt.textContent = excerptText;
			excerpt.hidden = !excerptText;
		}
		if (time) {
			time.textContent = timeText;
			time.hidden = !timeText;
		}
		if (place) {
			place.textContent = placeText;
			place.hidden = !placeText;
		}
	}

	$slider.on('init afterChange', function (event, slick, currentSlide) {
		var index = typeof currentSlide === 'number' ? currentSlide : slick.currentSlide || 0;
		var slideNode = slick.$slides ? slick.$slides.get(index) : null;
		syncSpotlight(slideNode);
	});

	$slider.slick({
		dots: true,
		arrows: true,
		fade: true,
		cssEase: 'linear',
		autoplay: true,
		autoplaySpeed: 5500,
		speed: 600,
		pauseOnHover: true,
		adaptiveHeight: false,
		appendArrows: $(root),
		appendDots: $(root),
		prevArrow: '<button type="button" class="events-hero__arrow events-hero__arrow--prev" aria-label="Previous event"></button>',
		nextArrow: '<button type="button" class="events-hero__arrow events-hero__arrow--next" aria-label="Next event"></button>'
	});
}

function initializeImageRotation() {
    const cards = document.querySelectorAll('.flex-cards__item-inner');
    
    cards.forEach(card => {
        const images = card.querySelectorAll('.flex-cards__image');
        
        // Only proceed if we have multiple images
        if (images && images.length > 1) {
            let currentIndex = 0;
            images[0].classList.add('active'); // Ensure first image is visible
            
            // Generate random interval between 2000ms (2s) and 5000ms (5s)
            const randomInterval = Math.floor(Math.random() * (5000 - 2000 + 1) + 2000);
            
            setInterval(() => {
                // Remove active class from current image
                images[currentIndex].classList.remove('active');
                
                // Move to next image
                currentIndex = (currentIndex + 1) % images.length;
                
                // Add active class to next image
                images[currentIndex].classList.add('active');
            }, randomInterval); // Random speed for each card
        } else if (images && images.length === 1) {
            // If only one image, make sure it's visible
            images[0].classList.add('active');
        }
    });
}

// Initialize when document is ready
jQuery(document).ready(function($) {
    initializeImageRotation();
});

// Re-initialize when new content might be loaded
jQuery(document).on('ajaxComplete', function() {
    initializeImageRotation();
});


document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('#masthead');
  
  const handleScroll = () => {
    if (window.scrollY > 100) {
      header.classList.add('sticky');
    } else {
      header.classList.remove('sticky');
    }
  };

  // Initial check in case page is loaded scrolled down
  handleScroll();
  
  // Add scroll event listener
  window.addEventListener('scroll', handleScroll);
});

document.addEventListener('DOMContentLoaded', function () {
	var list = document.getElementById('region-menu-list');
	var more = document.querySelector('.region-nav__more');
	var moreList = document.getElementById('region-menu-more');
	var moreButton = document.querySelector('.region-nav__more-button');
	if (!list || !more || !moreList || !moreButton) {
		return;
	}

	function layoutRegionNav() {
		while (moreList.firstElementChild) {
			list.appendChild(moreList.firstElementChild);
		}
		more.hidden = true;
		moreButton.setAttribute('aria-expanded', 'false');
		moreList.hidden = true;

		var guard = 0;
		while (list.scrollWidth > list.clientWidth + 1 && list.children.length > 1 && guard < 40) {
			more.hidden = false;
			moreList.insertBefore(list.lastElementChild, moreList.firstChild);
			guard += 1;
		}
	}

	moreButton.addEventListener('click', function () {
		var open = moreButton.getAttribute('aria-expanded') === 'true';
		moreButton.setAttribute('aria-expanded', open ? 'false' : 'true');
		moreList.hidden = open;
	});

	document.addEventListener('click', function (event) {
		if (!event.target.closest('.region-nav__more')) {
			moreButton.setAttribute('aria-expanded', 'false');
			moreList.hidden = true;
		}
	});

	window.addEventListener('resize', layoutRegionNav);
	window.addEventListener('load', layoutRegionNav);
	layoutRegionNav();
});

function pbcBindEventFilters() {
	document.querySelectorAll('.event-filter').forEach(function (block) {
		if (block.getAttribute('data-filters-ready') === 'true') {
			return;
		}
		block.setAttribute('data-filters-ready', 'true');

		var buttons = block.querySelectorAll('.event-filter__filter');
		var cards = block.querySelectorAll('.event-filter__card');
		var empty = block.querySelector('.event-filter__none');
		if (!buttons.length) {
			return;
		}

		buttons.forEach(function (button) {
			button.addEventListener('click', function () {
				var slug = button.getAttribute('data-filter');
				var shown = 0;

				buttons.forEach(function (item) {
					var on = item === button;
					item.classList.toggle('is-active', on);
					item.setAttribute('aria-pressed', on ? 'true' : 'false');
				});

				cards.forEach(function (card) {
					var match = slug === 'all' || card.getAttribute('data-type') === slug;
					card.hidden = !match;
					if (match) {
						shown += 1;
					}
				});

				if (empty) {
					empty.hidden = shown !== 0;
				}
			});
		});
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', pbcBindEventFilters);
} else {
	pbcBindEventFilters();
}

function pbcBindEventsArchive() {
	document.querySelectorAll('.events-archive').forEach(function (block) {
		if (block.getAttribute('data-filters-ready') === 'true') {
			return;
		}
		block.setAttribute('data-filters-ready', 'true');

		var bounds = {
			today: [block.dataset.today, block.dataset.today],
			weekend: [block.dataset.weekendStart, block.dataset.weekendEnd],
			week: [block.dataset.weekStart, block.dataset.weekEnd],
			month: [block.dataset.monthStart, block.dataset.monthEnd]
		};
		var rangeButtons = block.querySelectorAll('.events-archive__ranges .events-archive__pill');
		var typeButtons = block.querySelectorAll('.events-archive__types .events-archive__pill');
		var items = block.querySelectorAll('.events-archive__item');
		var calEvents = block.querySelectorAll('.events-archive__cal-event');
		var days = block.querySelectorAll('.events-archive__cal-day');
		var town = block.querySelector('.events-archive__select');
		var free = block.querySelector('.events-archive__free-input');
		var list = block.querySelector('.events-archive__list');
		var month = block.querySelector('.events-archive__month');
		var empty = block.querySelector('.events-archive__empty');
		var countNum = block.querySelector('.events-archive__count-num');
		var countWord = block.querySelector('.events-archive__count-word');
		var countRange = block.querySelector('.events-archive__count-range');
		var viewButtons = document.querySelectorAll('.events-hero__button');
		var range = 'week';
		var type = 'all';

		function activeRangeLabel() {
			var label = 'this week';
			rangeButtons.forEach(function (button) {
				if (button.classList.contains('is-active')) {
					label = button.getAttribute('data-label') || label;
				}
			});
			return label;
		}

		function matches(node) {
			var date = node.getAttribute('data-date') || '';
			var span = bounds[range] || bounds.week;
			if (!span[0] || date < span[0] || date > span[1]) {
				return false;
			}
			if (type !== 'all' && node.getAttribute('data-type') !== type) {
				return false;
			}
			if (town && town.value !== 'all' && node.getAttribute('data-place') !== town.value) {
				return false;
			}
			if (free && free.checked && node.getAttribute('data-free') !== '1') {
				return false;
			}
			return true;
		}

		function applyArchive() {
			var shown = 0;
			items.forEach(function (item) {
				var on = matches(item);
				item.hidden = !on;
				if (on) {
					shown += 1;
				}
			});
			calEvents.forEach(function (item) {
				item.hidden = !matches(item);
			});
			days.forEach(function (day) {
				var date = day.getAttribute('data-date') || '';
				var span = bounds[range] || bounds.week;
				day.classList.toggle('is-outside', !date || date < span[0] || date > span[1]);
			});
			if (countNum) {
				countNum.textContent = String(shown);
			}
			if (countWord) {
				countWord.textContent = shown === 1 ? 'event' : 'events';
			}
			if (countRange) {
				countRange.textContent = activeRangeLabel();
			}
			if (empty) {
				empty.hidden = shown !== 0;
				empty.textContent = 'No events ' + activeRangeLabel() + '.';
			}
		}

		function setPressed(buttons, current) {
			buttons.forEach(function (button) {
				var on = button === current;
				button.classList.toggle('is-active', on);
				button.setAttribute('aria-pressed', on ? 'true' : 'false');
			});
		}

		rangeButtons.forEach(function (button) {
			button.addEventListener('click', function () {
				range = button.getAttribute('data-range') || 'week';
				setPressed(rangeButtons, button);
				applyArchive();
			});
		});

		typeButtons.forEach(function (button) {
			button.addEventListener('click', function () {
				type = button.getAttribute('data-type') || 'all';
				setPressed(typeButtons, button);
				applyArchive();
			});
		});

		if (town) {
			town.addEventListener('change', applyArchive);
		}
		if (free) {
			free.addEventListener('change', applyArchive);
		}

		var params = new URLSearchParams(window.location.search);
		var placeParam = params.get('place');
		var typeParam = params.get('type');
		var rangeParam = params.get('range');
		if (placeParam && town) {
			Array.prototype.forEach.call(town.options, function (option) {
				if (option.value === placeParam) {
					town.value = placeParam;
				}
			});
		}
		if (typeParam) {
			typeButtons.forEach(function (button) {
				if (button.getAttribute('data-type') === typeParam) {
					type = typeParam;
					setPressed(typeButtons, button);
				}
			});
		}
		if (rangeParam) {
			rangeButtons.forEach(function (button) {
				if (button.getAttribute('data-range') === rangeParam) {
					range = rangeParam;
					setPressed(rangeButtons, button);
				}
			});
		}

		viewButtons.forEach(function (button) {
			button.addEventListener('click', function () {
				var view = button.getAttribute('data-view');
				var monthOn = view === 'month';
				if (list) {
					list.hidden = monthOn;
				}
				if (month) {
					month.hidden = !monthOn;
				}
				viewButtons.forEach(function (item) {
					var on = item === button;
					item.classList.toggle('is-active', on);
					item.setAttribute('aria-pressed', on ? 'true' : 'false');
				});
			});
		});

		applyArchive();
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', pbcBindEventsArchive);
} else {
	pbcBindEventsArchive();
}

function pbcBindJobsArchive() {
	document.querySelectorAll('.jobs-archive').forEach(function (board) {
		if (board.getAttribute('data-filters-ready') === 'true') {
			return;
		}
		board.setAttribute('data-filters-ready', 'true');

		var input = board.querySelector('.jobs-hero__input');
		var town = board.querySelector('.jobs-hero__select');
		var pills = board.querySelectorAll('.jobs-hero__pill');
		var cards = board.querySelectorAll('.jobs-board__card');
		var empty = board.querySelector('.jobs-board__empty');
		var countNum = board.querySelector('.jobs-board__count-num');
		var countWord = board.querySelector('.jobs-board__count-word');
		var field = 'all';

		function applyJobs() {
			var query = input ? input.value.trim().toLowerCase() : '';
			var townSlug = town ? town.value : '';
			var shown = 0;

			cards.forEach(function (card) {
				var fields = (card.getAttribute('data-fields') || '').split(' ');
				var haystack = card.getAttribute('data-search') || '';
				var matchField = field === 'all' || fields.indexOf(field) !== -1;
				var matchTown = !townSlug || card.getAttribute('data-town') === townSlug;
				var matchQuery = !query || haystack.indexOf(query) !== -1;
				var match = matchField && matchTown && matchQuery;
				card.hidden = !match;
				if (match) {
					shown += 1;
				}
			});

			if (countNum) {
				countNum.textContent = String(shown);
			}
			if (countWord) {
				countWord.textContent = shown === 1 ? 'job' : 'jobs';
			}
			if (empty) {
				empty.hidden = shown !== 0;
			}
		}

		pills.forEach(function (pill) {
			pill.addEventListener('click', function () {
				field = pill.getAttribute('data-field') || 'all';
				pills.forEach(function (item) {
					var on = item === pill;
					item.classList.toggle('is-active', on);
					item.setAttribute('aria-pressed', on ? 'true' : 'false');
				});
				applyJobs();
			});
		});

		if (input) {
			input.addEventListener('input', applyJobs);
		}
		if (town) {
			town.addEventListener('change', applyJobs);
		}

		var alertForm = board.querySelector('.jobs-alert__form');
		if (alertForm) {
			alertForm.addEventListener('submit', function (event) {
				event.preventDefault();
				var email = alertForm.querySelector('.jobs-alert__email');
				if (email && email.value && window.localStorage) {
					window.localStorage.setItem('pbcJobAlertEmail', email.value);
				}
				var done = alertForm.querySelector('.jobs-alert__done');
				if (done) {
					done.hidden = false;
				}
				alertForm.reset();
			});
		}
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', pbcBindJobsArchive);
} else {
	pbcBindJobsArchive();
}

function pbcBindComingSoonArchive() {
	document.querySelectorAll('.coming-soon-archive').forEach(function (board) {
		if (board.getAttribute('data-filters-ready') === 'true') {
			return;
		}
		board.setAttribute('data-filters-ready', 'true');

		var input = board.querySelector('.coming-soon-hero__input');
		var town = board.querySelector('.coming-soon-hero__select');
		var pills = board.querySelectorAll('.coming-soon-hero__pill');
		var cards = board.querySelectorAll('.coming-soon-board__card');
		var empty = board.querySelector('.coming-soon-board__empty');
		var countNum = board.querySelector('.coming-soon-board__count-num');
		var countWord = board.querySelector('.coming-soon-board__count-word');
		var stage = 'all';

		function applyComingSoon() {
			var query = input ? input.value.trim().toLowerCase() : '';
			var townSlug = town ? town.value : '';
			var shown = 0;

			cards.forEach(function (card) {
				var matchStage = stage === 'all' || card.getAttribute('data-stage') === stage;
				var matchTown = !townSlug || card.getAttribute('data-town') === townSlug;
				var haystack = card.getAttribute('data-search') || '';
				var matchQuery = !query || haystack.indexOf(query) !== -1;
				var match = matchStage && matchTown && matchQuery;
				card.hidden = !match;
				if (match) {
					shown += 1;
				}
			});

			if (countNum) {
				countNum.textContent = String(shown);
			}
			if (countWord) {
				countWord.textContent = shown === 1 ? 'opening' : 'openings';
			}
			if (empty) {
				empty.hidden = shown !== 0;
			}
		}

		pills.forEach(function (pill) {
			pill.addEventListener('click', function () {
				stage = pill.getAttribute('data-stage') || 'all';
				pills.forEach(function (item) {
					var on = item === pill;
					item.classList.toggle('is-active', on);
					item.setAttribute('aria-pressed', on ? 'true' : 'false');
				});
				applyComingSoon();
			});
		});

		if (input) {
			input.addEventListener('input', applyComingSoon);
		}
		if (town) {
			town.addEventListener('change', applyComingSoon);
		}

		var params = new URLSearchParams(window.location.search);
		var placeParam = params.get('place') || '';
		var stageParam = params.get('stage') || '';
		if (town && placeParam) {
			town.value = placeParam;
		}
		if (stageParam) {
			var matchPill = null;
			pills.forEach(function (pill) {
				if (pill.getAttribute('data-stage') === stageParam) {
					matchPill = pill;
				}
			});
			if (matchPill) {
				matchPill.click();
			} else {
				applyComingSoon();
			}
		} else {
			applyComingSoon();
		}

		var alertForm = board.querySelector('.coming-soon-alert__form');
		if (alertForm) {
			alertForm.addEventListener('submit', function (event) {
				event.preventDefault();
				var email = alertForm.querySelector('.coming-soon-alert__email');
				if (email && email.value && window.localStorage) {
					window.localStorage.setItem('pbcOpeningAlertEmail', email.value);
				}
				var done = alertForm.querySelector('.coming-soon-alert__done');
				if (done) {
					done.hidden = false;
				}
				alertForm.reset();
			});
		}
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', pbcBindComingSoonArchive);
} else {
	pbcBindComingSoonArchive();
}

function pbcBindDirectory() {
	document.querySelectorAll('.directory').forEach(function (root) {
		if (root.getAttribute('data-filters-ready') === 'true') {
			return;
		}
		root.setAttribute('data-filters-ready', 'true');

		var input = root.querySelector('.directory-hero__input');
		var townInput = root.querySelector('.directory-hero__town-input');
		var townButtons = root.querySelectorAll('.directory-towns__pill');
		var form = root.querySelector('.directory-hero__bar');
		var heroTitle = root.querySelector('.directory-hero__title');
		var sheetTitle = root.querySelector('.directory-sheet__title');
		var categoryButtons = root.querySelectorAll('.directory-cats__pill');
		var tierButtons = root.querySelectorAll('.directory-tools__pill');
		var claim = root.querySelector('.directory-tools__claim');
		var licenseButtons = root.querySelectorAll('[data-licenses]');
		var cards = root.querySelectorAll('.directory-card');
		var empty = root.querySelector('.directory-board__empty');
		var sample = root.querySelector('.directory-sample');
		var countNum = root.querySelector('.directory-board__count-num');
		var countWord = root.querySelector('.directory-board__count-word');
		var category = 'all';
		var tier = 'all';
		var licenses = false;
		var townSlug = townInput ? townInput.value : '';
		var $carousel = window.jQuery ? window.jQuery(root).find('[data-directory-carousel]') : null;
		var carouselReady = false;

		if ($carousel && $carousel.length && typeof $carousel.slick === 'function') {
			var nav = root.querySelector('.directory-featured__nav');
			var $ = window.jQuery;
			if (nav && !nav.querySelector('.directory-featured__arrow')) {
				nav.innerHTML =
					'<button type="button" class="directory-featured__arrow directory-featured__arrow--prev" aria-label="Previous businesses"></button>' +
					'<button type="button" class="directory-featured__arrow directory-featured__arrow--next" aria-label="Next businesses"></button>';
			}
			var $prev = $(root).find('.directory-featured__arrow--prev');
			var $next = $(root).find('.directory-featured__arrow--next');
			$carousel.slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				infinite: false,
				dots: false,
				arrows: true,
				prevArrow: $prev,
				nextArrow: $next,
				responsive: [
					{
						breakpoint: 1100,
						settings: { slidesToShow: 2 }
					},
					{
						breakpoint: 700,
						settings: { slidesToShow: 1 }
					}
				]
			});
			carouselReady = true;
		}

		function filterCarousel() {
			if (!carouselReady || !$carousel) {
				return;
			}
			$carousel.slick('slickUnfilter');
			if (!townSlug) {
				return;
			}
			$carousel.slick('slickFilter', function () {
				var town = this.getAttribute('data-town');
				if (this.classList.contains('directory-featured__slide--slot')) {
					return true;
				}
				return town === townSlug;
			});
		}

		categoryButtons.forEach(function (button) {
			if (button.classList.contains('is-active')) {
				category = button.getAttribute('data-category') || 'all';
			}
		});
		tierButtons.forEach(function (button) {
			if (button.classList.contains('is-active')) {
				tier = button.getAttribute('data-tier') || 'all';
			}
		});
		licenseButtons.forEach(function (button) {
			if (button.classList.contains('is-active')) {
				licenses = true;
			}
		});

		function setPressed(buttons, current) {
			buttons.forEach(function (button) {
				var on = button === current;
				button.classList.toggle('is-active', on);
				button.setAttribute('aria-pressed', on ? 'true' : 'false');
			});
		}

		function matches(card, kind) {
			var query = input ? input.value.trim().toLowerCase() : '';
			var haystack = card.getAttribute('data-search') || '';
			var place = card.getAttribute('data-town') || '';
			if (townSlug && place !== townSlug) {
				return false;
			}
			if (query && haystack.indexOf(query) === -1) {
				return false;
			}
			if (kind === 'license') {
				return licenses;
			}
			if (licenses) {
				return false;
			}
			if (category !== 'all') {
				var cats = (card.getAttribute('data-category') || '').split(' ');
				if (cats.indexOf(category) === -1) {
					return false;
				}
			}
			if (tier !== 'all' && card.getAttribute('data-tier') !== tier) {
				return false;
			}
			if (claim && claim.checked && card.getAttribute('data-claimed') === '1') {
				return false;
			}
			return true;
		}

		function applyDirectory() {
			var shown = 0;
			var sampleShown = 0;
			cards.forEach(function (card) {
				var kind = card.getAttribute('data-kind') === 'license' ? 'license' : 'business';
				var on = matches(card, kind);
				card.hidden = !on;
				if (on) {
					shown += 1;
					if (card.getAttribute('data-sample') === '1') {
						sampleShown += 1;
					}
				}
			});
			filterCarousel();
			if (countNum) {
				countNum.textContent = String(shown);
			}
			if (countWord) {
				if (licenses) {
					countWord.textContent = shown === 1 ? 'new license' : 'new licenses';
				} else {
					countWord.textContent = shown === 1 ? 'business' : 'businesses';
				}
			}
			if (sample) {
				sample.hidden = shown === 0 || sampleShown !== shown;
			}
			if (empty) {
				empty.hidden = shown !== 0;
				empty.textContent = licenses ? 'No new licenses match those filters.' : 'No businesses match those filters.';
			}
		}

		categoryButtons.forEach(function (button) {
			button.addEventListener('click', function () {
				category = button.getAttribute('data-category') || 'all';
				licenses = false;
				licenseButtons.forEach(function (item) {
					item.classList.remove('is-active');
					item.setAttribute('aria-pressed', 'false');
				});
				setPressed(categoryButtons, button);
				applyDirectory();
			});
		});

		tierButtons.forEach(function (button) {
			button.addEventListener('click', function () {
				var next = button.getAttribute('data-tier') || 'all';
				if (button.classList.contains('is-active')) {
					tier = 'all';
					button.classList.remove('is-active');
					button.setAttribute('aria-pressed', 'false');
				} else {
					tier = next;
					setPressed(tierButtons, button);
				}
				licenses = false;
				licenseButtons.forEach(function (item) {
					item.classList.remove('is-active');
					item.setAttribute('aria-pressed', 'false');
				});
				applyDirectory();
			});
		});

		licenseButtons.forEach(function (button) {
			button.addEventListener('click', function () {
				licenses = !licenses;
				licenseButtons.forEach(function (item) {
					item.classList.toggle('is-active', licenses);
					item.setAttribute('aria-pressed', licenses ? 'true' : 'false');
				});
				applyDirectory();
			});
		});

		if (input) {
			input.addEventListener('input', applyDirectory);
		}
		townButtons.forEach(function (button) {
			button.addEventListener('click', function () {
				townSlug = button.getAttribute('data-town') || '';
				if (townInput) {
					townInput.value = townSlug;
				}
				setPressed(townButtons, button);
				var label = button.textContent.trim();
				if (heroTitle) {
					heroTitle.textContent = townSlug ? label : 'Palm Beach County';
				}
				if (sheetTitle) {
					sheetTitle.textContent = townSlug ? (label + ' businesses') : 'Local businesses right now';
				}
				applyDirectory();
			});
		});
		if (claim) {
			claim.addEventListener('change', applyDirectory);
		}
		if (form) {
			form.addEventListener('submit', function (event) {
				event.preventDefault();
				applyDirectory();
			});
		}

		applyDirectory();
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', pbcBindDirectory);
} else {
	pbcBindDirectory();
}

function pbcBindEventSingle() {
	document.querySelectorAll('.event-single').forEach(function (root) {
		if (root.getAttribute('data-single-ready') === 'true') {
			return;
		}
		root.setAttribute('data-single-ready', 'true');

		var gallery = root.querySelector('[data-gallery]');
		if (gallery) {
			var slides = gallery.querySelectorAll('.event-single__slide');
			var thumbs = gallery.querySelectorAll('.event-single__thumb');
			var caption = gallery.querySelector('[data-gallery-caption]');
			var counter = gallery.querySelector('[data-gallery-count]');
			var index = 0;

			function showSlide(next) {
				if (!slides.length) {
					return;
				}
				index = (next + slides.length) % slides.length;
				slides.forEach(function (slide, slideIndex) {
					slide.hidden = slideIndex !== index;
				});
				thumbs.forEach(function (thumb, thumbIndex) {
					thumb.classList.toggle('is-active', thumbIndex === index);
				});
				if (caption) {
					caption.textContent = slides[index].getAttribute('data-caption') || '';
				}
				if (counter) {
					counter.textContent = (index + 1) + ' / ' + slides.length;
				}
			}

			var prev = gallery.querySelector('[data-gallery-prev]');
			var nextButton = gallery.querySelector('[data-gallery-next]');
			if (prev) {
				prev.addEventListener('click', function () {
					showSlide(index - 1);
				});
			}
			if (nextButton) {
				nextButton.addEventListener('click', function () {
					showSlide(index + 1);
				});
			}
			thumbs.forEach(function (thumb) {
				thumb.addEventListener('click', function () {
					showSlide(parseInt(thumb.getAttribute('data-gallery-go'), 10) || 0);
				});
			});
		}

		var countdown = root.querySelector('.event-single__countdown');
		if (countdown) {
			var start = Date.parse(countdown.getAttribute('data-start'));
			var note = root.querySelector('.event-single__countdown-note');
			var units = {
				days: countdown.querySelector('[data-unit="days"]'),
				hours: countdown.querySelector('[data-unit="hours"]'),
				minutes: countdown.querySelector('[data-unit="minutes"]'),
				seconds: countdown.querySelector('[data-unit="seconds"]')
			};

			function pad(value) {
				return value < 10 ? '0' + value : String(value);
			}

			function tick() {
				var diff = start - Date.now();
				if (!start || diff <= 0) {
					countdown.hidden = true;
					if (note) {
						note.hidden = false;
						note.textContent = 'This event has started';
					}
					return;
				}
				var seconds = Math.floor(diff / 1000);
				units.days.textContent = pad(Math.floor(seconds / 86400));
				units.hours.textContent = pad(Math.floor((seconds % 86400) / 3600));
				units.minutes.textContent = pad(Math.floor((seconds % 3600) / 60));
				units.seconds.textContent = pad(seconds % 60);
			}

			tick();
			window.setInterval(tick, 1000);
		}

		var share = root.querySelector('.event-single__share');
		if (share) {
			share.addEventListener('click', function () {
				var url = share.getAttribute('data-url') || window.location.href;
				var title = share.getAttribute('data-title') || document.title;

				function copied() {
					share.textContent = 'Link copied';
				}

				function fallbackCopy() {
					var input = document.createElement('input');
					input.value = url;
					input.setAttribute('readonly', 'readonly');
					input.style.position = 'fixed';
					input.style.left = '-9999px';
					document.body.appendChild(input);
					input.select();
					var ok = false;
					try {
						ok = document.execCommand('copy');
					} catch (error) {
						ok = false;
					}
					input.remove();
					if (ok) {
						copied();
						return;
					}
					window.prompt('Copy this link', url);
				}

				if (navigator.share) {
					navigator.share({ title: title, url: url }).catch(function () {});
					return;
				}
				if (navigator.clipboard && navigator.clipboard.writeText) {
					navigator.clipboard.writeText(url).then(copied).catch(fallbackCopy);
					return;
				}
				fallbackCopy();
			});
		}
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', pbcBindEventSingle);
} else {
	pbcBindEventSingle();
}

/**
 * Native sideways scroll for post-cards rows that exceed the visible limit.
 * Auto-advances, loops back to the start, and hides the native scrollbar in CSS.
 */
function pbcBindPostCardsSliders() {
	document.querySelectorAll('[data-post-cards-slider]').forEach(function (root) {
		if (root.getAttribute('data-slider-ready') === 'true') {
			return;
		}
		root.setAttribute('data-slider-ready', 'true');

		var track = root.querySelector('.post-cards__grid');
		var nav = root.querySelector('.post-cards__nav');
		var prev = root.querySelector('.post-cards__arrow--prev');
		var next = root.querySelector('.post-cards__arrow--next');
		if (!track || !nav || !prev || !next) {
			return;
		}

		nav.hidden = false;
		prev.disabled = false;
		next.disabled = false;

		var autoplayMs = 4500;
		var timer = null;
		var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		function stepSize() {
			var card = track.querySelector('.post-cards__card');
			if (!card) {
				return track.clientWidth;
			}
			var styles = window.getComputedStyle(track);
			var gap = parseFloat(styles.columnGap || styles.gap) || 0;
			return card.getBoundingClientRect().width + gap;
		}

		function maxScroll() {
			return Math.max(0, track.scrollWidth - track.clientWidth);
		}

		function atStart() {
			return track.scrollLeft <= 1;
		}

		function atEnd() {
			return track.scrollLeft >= maxScroll() - 1;
		}

		function updateEdgeState() {
			root.classList.toggle('is-at-end', atEnd());
		}

		function goNext() {
			if (atEnd()) {
				track.scrollTo({ left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
				return;
			}
			track.scrollBy({ left: stepSize(), behavior: reduceMotion ? 'auto' : 'smooth' });
		}

		function goPrev() {
			if (atStart()) {
				track.scrollTo({ left: maxScroll(), behavior: reduceMotion ? 'auto' : 'smooth' });
				return;
			}
			track.scrollBy({ left: -stepSize(), behavior: reduceMotion ? 'auto' : 'smooth' });
		}

		function stopAutoplay() {
			if (timer) {
				window.clearInterval(timer);
				timer = null;
			}
		}

		function startAutoplay() {
			stopAutoplay();
			if (reduceMotion || maxScroll() < 2) {
				return;
			}
			timer = window.setInterval(goNext, autoplayMs);
		}

		prev.addEventListener('click', function () {
			goPrev();
			startAutoplay();
		});
		next.addEventListener('click', function () {
			goNext();
			startAutoplay();
		});

		var ticking = false;
		track.addEventListener('scroll', function () {
			if (ticking) {
				return;
			}
			ticking = true;
			window.requestAnimationFrame(function () {
				updateEdgeState();
				ticking = false;
			});
		}, { passive: true });

		window.addEventListener('resize', updateEdgeState, { passive: true });

		root.addEventListener('mouseenter', stopAutoplay);
		root.addEventListener('mouseleave', startAutoplay);
		root.addEventListener('focusin', stopAutoplay);
		root.addEventListener('focusout', function (event) {
			if (!root.contains(event.relatedTarget)) {
				startAutoplay();
			}
		});

		document.addEventListener('visibilitychange', function () {
			if (document.hidden) {
				stopAutoplay();
			} else {
				startAutoplay();
			}
		});

		updateEdgeState();
		startAutoplay();
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', pbcBindPostCardsSliders);
} else {
	pbcBindPostCardsSliders();
}
